module.exports = __webpack_public_path__ + "img/epistemic-defeat--epistemic-studies-cover.187b65c6.jpg";